// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"075e8630","239":"ec8b2f7b","453":"4fcbd3ac","732":"3f6cbe94"}[chunkId] + ".chunk.js";
};